import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';
import { isHelixOnlyHub } from 'utils/helix/isHelixOnlyHub';
import { useUpdateMyUserSettings } from 'actions/userSettings';
import PageSection from 'components/PageSection';
import UserPageHeader from 'components/UserPageHeader';
import Heading from 'components/Heading';
import Stack from 'components/Stack';
import Card from 'components/Card';
import Text from 'components/Text';
import TextLink from 'components/TextLink';
import Button from 'components/Button';
import Flex from 'components/Flex';
import Landmark from 'components/Landmark';
import { usersQueryKeys } from 'actions/users';
import useCustomContactLink from 'hooks/useCustomContactLink';
function ContactLink(_ref) {
  var children = _ref.children;
  var contactLink = useCustomContactLink();
  if (contactLink.url) {
    return /*#__PURE__*/React.createElement(TextLink, {
      href: contactLink.url,
      target: "_blank"
    }, children);
  }
  return /*#__PURE__*/React.createElement(TextLink, {
    as: "button",
    onClick: contactLink.openModal
  }, children);
}
var HubLink = function HubLink(_ref2) {
  var domain = _ref2.domain,
    children = _ref2.children;
  if (!domain) {
    return /*#__PURE__*/React.createElement(Text, null, children);
  }
  return /*#__PURE__*/React.createElement(TextLink, {
    as: "a",
    href: domain,
    target: "_blank"
  }, children);
};
function HelixNotAvailablePage(_ref3) {
  var isCurrentUser = _ref3.isCurrentUser,
    userId = _ref3.userId,
    user = _ref3.user,
    helixHubDomain = _ref3.helixHubDomain,
    helixHubName = _ref3.helixHubName;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var queryClient = useQueryClient();
  var _useUpdateMyUserSetti = useUpdateMyUserSettings(),
    updateUserSettings = _useUpdateMyUserSetti.updateUserSettings;
  return /*#__PURE__*/React.createElement(PageSection, {
    flush: true
  }, /*#__PURE__*/React.createElement(Stack, {
    spacing: "l",
    maxWidth: 860,
    mb: "m",
    mt: isHelixOnlyHub ? 'm' : '0'
  }, user && /*#__PURE__*/React.createElement(UserPageHeader, user), /*#__PURE__*/React.createElement(Heading, {
    as: "h2"
  }, t(isCurrentUser ? helixHubDomain ? 'skills_helix_not_linked_title' : 'error_forbidden' : 'skills_admin_helix_not_linked_title')), /*#__PURE__*/React.createElement(Card, {
    p: "m"
  }, isCurrentUser ? helixHubDomain ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Stack, {
    spacing: "s"
  }, /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: "skills_helix_not_linked_text_1",
    values: {
      helixHubName: helixHubName,
      helixHubDomain: helixHubDomain
    }
  }, "Helix can only be linked to one hub that you are a member of, and at the moment you have it linked to", ' ', /*#__PURE__*/React.createElement("strong", null, helixHubName), " (", /*#__PURE__*/React.createElement(HubLink, {
    domain: helixHubDomain
  }, helixHubDomain), ")."), /*#__PURE__*/React.createElement(Text, null, t('skills_helix_not_linked_text_2')), /*#__PURE__*/React.createElement(Text, null, t('skills_helix_not_linked_text_3'))), /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    justifyContent: "center",
    mt: "m"
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return updateUserSettings({
              is_helix_hub: true
            });
          case 2:
            _context.next = 4;
            return queryClient.invalidateQueries(usersQueryKeys.helixAccess(userId));
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))
  }, t('actions_use_this_hub_for_helix')))) : /*#__PURE__*/React.createElement(Landmark, null, /*#__PURE__*/React.createElement(Text, null, /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: "error_content_access_denied"
  }, "You do not have permission to view this content. If you think this is an error, please", /*#__PURE__*/React.createElement(ContactLink, null, "let us know"), "."))) : /*#__PURE__*/React.createElement(Stack, {
    spacing: "s"
  }, /*#__PURE__*/React.createElement(Text, null, t('skills_admin_helix_not_linked_text_1')), /*#__PURE__*/React.createElement(Text, null, t('skills_admin_helix_not_linked_text_2'))))));
}
export default HelixNotAvailablePage;